<template>
  <div class="container">
    <div class="title">
      <div class="title-text">
        STR任务配置
        <span>（STR任务需要同时达标合并考核）</span>
      </div>
      <div class="handle-box">
        <el-button type="primary" plain size="medium" @click="addStrTask" v-if="edit">新增</el-button>
        <slot></slot>
      </div>
    </div>
    <div style="padding:20px" v-if="strList.length">
      <el-table
        :data="currentList"
        class="bonus-table"
        :header-cell-style="{
            background: '#f0f0f0',
            color: '#606266',
            lineHeight: '20px',
            fontSize: '14px',
            textAlign: 'center',
            height: '50px'
          }"
      >
        <el-table-column fixed="left" width="130px" align="center" label="序号" prop="index">
          <template slot-scope="scope">
            <div>{{scope.row.sequenceFlag}}</div>
          </template>
        </el-table-column>
        <el-table-column fixed="left" width="180px" align="center">
          <template slot="header">
            <div>
              <i class="require-icon" v-if="edit">*</i> 任务名称
            </div>
          </template>
          <template slot-scope="scope">
            <div>
              <el-input placeholder="请输入" v-model="scope.row.defineName" :disabled="!edit"></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="left" width="180px" align="center">
          <template slot="header">
            <div>
              <i class="require-icon" v-if="edit">*</i> 考核单品
            </div>
          </template>
          <template slot-scope="scope">
            <div v-if="!scope.row.salesRuleInfo.items.length">
              <el-button type="danger" plain size="medium" @click="setStrScope(scope.row.sequenceFlag)" v-if="edit">选择</el-button>
            </div>
            <div v-else>
              <RegionStrPopover :value="scope.row.salesRuleInfo.items"></RegionStrPopover>
              <div>
                <el-button type="text" size="medium" @click="setStrScope(scope.row.sequenceFlag)" v-if="edit">修改</el-button>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column v-for="item,index in monthList" :key="index" min-width="200px">
          <template slot="header">
            <div>
              <i class="require-icon" v-if="edit">*</i>
              {{item.year}}年{{item.month}}月
            </div>
            <div style="font-size:12px">目标销量</div>
          </template>
          <template slot-scope="scope">
            <div style="text-align:center">
              <el-input-number
                v-model="scope.row.salesRuleInfo.targets[index].qty"
                style="margin-right:5px"
                placeholder="请输入"
                @blur="handleToFixed(scope.$index, index)"
                :disabled="checkChangeDate(item) || !edit"
              ></el-input-number>
              <el-tooltip effect="light" content="一键同步" placement="top-start" v-if="index !== monthList.length - 1 && edit && !checkChangeDate(item)">
                <i class="el-icon-download sync-value" @click="syncStrValue(scope.row.sequenceFlag,index)"></i>
              </el-tooltip>
              <el-popover placement="top-start" width="250" trigger="hover"  v-if="checkChangeDate(item)">
                <div>实际考核单品</div>
                <RegionStrHistory title="" :value="scope.row.salesRuleInfo.targets" mode="01" :month="item"></RegionStrHistory>
                <RegionStrHistory title="SegMent" :value="scope.row.salesRuleInfo.targets" mode="02" :month="item"></RegionStrHistory>
                <RegionStrHistory title="品牌" :value="scope.row.salesRuleInfo.targets" mode="03" :month="item"></RegionStrHistory>
                <RegionStrHistory title="子品牌" :value="scope.row.salesRuleInfo.targets" mode="04" :month="item"></RegionStrHistory>
                <RegionStrHistory title="SKU" :value="scope.row.salesRuleInfo.targets" mode="05" :month="item"></RegionStrHistory>
                <i class="el-icon-question history-detail" slot="reference"></i>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" width="160px" align="center" v-if="edit">
          <template slot="header">
            <div>操作</div>
          </template>
          <template slot-scope="scope">
            <div>
              <el-button
                type="danger"
                plain
                size="medium"
                @click="delStrTask(scope.row.sequenceFlag)"
                v-if="!scope.row.scopeDefineId || themeStatus < 200"
              >删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          :current-page.sync="pageInfo.currentPage"
          :page-size="pageInfo.pageSize"
          layout="total, prev, pager, next"
          :total="strList.length"
          @current-change="getCurrentList"
        ></el-pagination>
      </div>
      <RegionStrDialog ref="regionStrDialog" @handleSetStrScope="handleSetStrScope" :scopeDataList="scopeDataList"></RegionStrDialog>
    </div>
    <div v-else class="nothing">您暂未配置STR任务</div>
  </div>
</template>

<script>
import RegionStrDialog from '@/views/trade/perfect2022/components/region-str-dialog.vue'
import RegionStrPopover from '@/views/trade/perfect2022/components/region-str-popover.vue'
import RegionStrHistory from '@/views/trade/perfect2022/components/region-str-history.vue'
import { mapGetters } from 'vuex'
export default {
  props: {
    edit: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: 'edit'
    },
    monthList: {
      type: Array,
      default: () => {
        return []
      }
    },
    strTaskList: {
      type: Array,
      default: () => {
        return []
      }
    },
    themeStatus: {
      default: 0
    },
    handleType: {
      type: String,
      default: ''
    },
    isDetailPage: {
      type: Boolean,
      default: false
    }
  },
  components: {
    RegionStrDialog,
    RegionStrPopover,
    RegionStrHistory
  },
  data () {
    return {
      employeeLevel: '',
      strList: [],
      sequenceFlag: 0,
      pageInfo: {
        currentPage: 1,
        pageSize: 5
      },
      currentList: [],
      index: '',
      scopeDataList: []
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created () {
    // this.init()
    this.employeeLevel = this.userInfo.employeeLevel
    this.getCurrentList()
  },
  watch: {
    monthList () {
      this.strList.forEach(strItem => {
        strItem.salesRuleInfo.targets = []
        this.monthList.forEach(item => {
          let obj = {
            month: item.year + '-' + item.month,
            qty: undefined
          }
          if (this.checkChangeDate(item)) {
            obj.qty = 0
          }
          strItem.salesRuleInfo.targets.push(obj)
        })
      })
    },
    strTaskList: {
      immediate: true,
      handler () {
        if (!this.strTaskList.length) {
          return
        }
        this.strList = JSON.parse(JSON.stringify(this.strTaskList)).map(item => {
          item.salesRuleInfo = JSON.parse(item.salesRuleInfo)
          // 去除已结束月份str配置
          if (this.handleType && this.handleType !== 'new') {
            item.salesRuleInfo.targets = item.salesRuleInfo.targets.filter(item => {
              const year = new Date().getFullYear()
              const month = new Date().getMonth() + 1
              const strYear = new Date(item.month).getFullYear()
              const strMonth = new Date(item.month).getMonth() + 1
              if (year < strYear || (year === strYear && strMonth >= month)) {
                return item
              }
            })
          }
          item.salesRuleInfo.items = item.salesRuleInfo.targets[item.salesRuleInfo.targets.length - 1]?.items || item.salesRuleInfo.items
          item.salesRuleInfo.items.map(item => {
            if (item.code) {
              let codeList = item.code?.split(',') || []
              let nameList = item.name?.split(',') || []
              let list = []
              codeList.forEach((item, index) => {
                let obj = {
                  brandName: nameList[index],
                  brandCode: item
                }
                list.push(obj)
              })
              item.code = list
            } else {
              item.code = []
            }
            return item
          })

          return item
        })
        this.getCurrentList()
      }
    }
  },
  methods: {
    init () {
    },
    addStrTask () {
      this.pageInfo.currentPage = 1
      this.sequenceFlag = 0
      this.strList.forEach((item) => {
        if (item.sequenceFlag > this.sequenceFlag) {
          this.sequenceFlag = item.sequenceFlag
        }
      })
      this.sequenceFlag++

      let list = []
      this.monthList.forEach(item => {
        let obj = {
          month: item.year + '-' + item.month,
          qty: undefined
        }
        if (this.checkChangeDate(item)) {
          obj.qty = 0
        }
        list.push(obj)
      })

      this.strList.unshift({
        taskType: '05',
        defineType: '05',
        defineName: '',
        salesRuleInfo: { items: [], targets: list },
        sequenceFlag: this.sequenceFlag
      })
      this.getCurrentList()
    },
    delStrTask (index) {
      this.index = this.strList.findIndex(item => {
        return item.sequenceFlag === index
      })
      this.strList.splice(this.index, 1)
      this.getCurrentList()
    },
    getCurrentList () {
      let startIndex = this.pageInfo.pageSize * (this.pageInfo.currentPage - 1)
      let endIndex = this.pageInfo.pageSize * this.pageInfo.currentPage
      this.currentList = this.strList.slice(startIndex, endIndex)
      if (!this.currentList.length && this.pageInfo.currentPage !== 1) {
        this.pageInfo.currentPage = this.pageInfo.currentPage - 1
        this.getCurrentList()
      }
    },
    setStrScope (index) {
      this.index = this.strList.findIndex(item => {
        return item.sequenceFlag === index
      })
      this.scopeDataList = this.strList[this.index].salesRuleInfo.items
      this.$refs.regionStrDialog.show()
    },
    handleSetStrScope (list) {
      this.strList[this.index].salesRuleInfo.items = list
    },
    syncStrValue (sequenceFlag, monthIndex) {
      let index = this.strList.findIndex(item => {
        return item.sequenceFlag === sequenceFlag
      })
      let val = this.strList[index].salesRuleInfo.targets[monthIndex].qty
      this.strList[index].salesRuleInfo.targets = this.strList[index].salesRuleInfo.targets.map((item, itemIndex) => {
        if (itemIndex > monthIndex) {
          item.qty = val
        }
        return item
      })
    },
    setValue () {
      if (!this.strList.length) {
        return true
      } else {
        for (let i = 0; i < this.strList.length; i++) {
          if (!this.strList[i].defineName) {
            this.$message.warning(`请输入STR任务配置 ${this.strList[i].sequenceFlag} 任务名称`)
            return false
          }
          if (!this.strList[i].salesRuleInfo.items.length) {
            this.$message.warning(`请选择STR任务配置 ${this.strList[i].sequenceFlag} 考核单品`)
            return false
          }
          for (let j = 0; j < this.strList[i].salesRuleInfo.targets.length; j++) {
            let item = this.strList[i].salesRuleInfo.targets[j]
            if (!item.qty && item.qty !== 0) {
              this.$message.warning(`请输入STR任务配置 ${this.strList[i].sequenceFlag} ${item.month} 考核数量`)
              return false
            }
          }
        }
        let list = JSON.parse(JSON.stringify(this.strList))
        for (let i = 0; i < list.length; i++) {
          list[i].salesRuleInfo.items.map(item => {
            let code = []
            item.code.forEach(sItem => {
              code.push(sItem.brandCode)
            })
            item.code = code.join(',')
          })
          list[i].salesRuleInfo.targets.map(item => {
            item.items = list[i].salesRuleInfo.items
            return item
          })
          delete list[i].salesRuleInfo.items
          // 复制活动 清空 scopeDefineId
          if (this.themeStatus === 0) {
            list[i].scopeDefineId = ''
          }
          list[i].salesRuleInfo = JSON.stringify(list[i].salesRuleInfo)
        }
        return list
      }
    },

    checkDecimalsCanZero: function (rule, value, callback) {
      if (Number(value) < 0 || !/^[0-9]+?$/.test(value)) {
        callback(new Error('请输入非负整数'))
      } else {
        callback()
      }
    },
    handleToFixed (strIndex, targetIndex) {
      const obj = { ...this.strList[strIndex].salesRuleInfo.targets[targetIndex] }
      if (obj.qty === '') return
      this.checkDecimalsCanZero('', obj.qty, (error) => {
        if (error) {
          this.$message.warning(`${error.message}`)
        }
      })
      obj.qty = this.setToFixed(obj.qty)
      this.strList[strIndex].salesRuleInfo.targets.splice(targetIndex, 1, obj)
    },
    setToFixed (num) {
      if (Math.ceil(num) > 0) {
        return Number(num).toFixed(0)
      }
      if (Math.ceil(num) === 0) {
        return 0
      }
      return undefined
    },
    checkChangeDate (date) {
      if ((!this.themeStatus || this.themeStatus < 200) && this.isDetailPage === false) {
        return false
      }
      let nowDate = new Date().getTime()
      let bonusDate = new Date(date.year + '/' + date.month + '/16').getTime()
      // 禁止修改
      if (nowDate > bonusDate) {
        return true
      }
      // 允许修改
      return false
    },
    toUpdateBonusStr () {
      this.$emit('toUpdateBonusStr')
    }
  }
}
</script>

<style lang="scss" scoped>
.el-table ::v-deep tr {
  // background: #f8f8f8;
  height: 100px;
}
.el-table ::v-deep thead tr {
  // background: #f8f8f8;
  height: 50px;
}
.el-table ::v-deep .el-table__fixed::before {
  height: 0px;
}
.el-input {
  width: 120px;
}
.el-input-number {
  width: 80px;
}
.el-input ::v-deep .el-input__inner,
.el-input-number ::v-deep .el-input__inner {
  height: 30px;
  line-height: 30px;
}
.el-button {
  width: 80px;
  height: 30px;
  padding: 0;
}
.require-icon {
  color: #c8102d;
  font-size: 16px;
  font-weight: 700;
  // margin-right: 10px;
}
.container {
  background-color: #fff;
}
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  padding: 20px 20px 0;
  .handle-box {
    // margin-right: 83px;
    .el-button {
      width: 80px;
      height: 30px;
      padding: 0 20px;
    }
  }
  .title-text {
    font-weight: 700;
    margin: 0;
    span {
      color: $base-red;
      font-weight: 400;
      font-size: 14px;
      padding-left: 20px;
    }
  }
  .el-button {
    width: 80px;
  }
}
.pagination {
  text-align: center;
  padding: 20px 0;
}
.nothing {
  background-color: #fff;
  padding: 50px 0 60px;
  text-align: center;
  margin: 0 auto;
}
.text-overflow {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  box-orient: vertical;
  line-clamp: 1;
  cursor: pointer;
}
.sync-value {
  display: inline-block;
  width: 30px;
  height: 25px;
  transform: rotate(-90deg);
  font-size: 20px;
  color: #409eff;
  cursor: pointer;
}
.history-detail{
  color: #409eff;
  font-size: 18px;
}
</style>
